module.exports = __webpack_public_path__ + "img/business_people_using_their_phones.0f7d4698.png";